export default __webpack_public_path__ + "static/media/localisation.c2c86106.jpg";